import React, { Fragment } from 'react'
import ReactHtmlParser from 'react-html-parser'
import hash from '@emotion/hash'

export type IdentifiersItemProps = {
  type: string
  value: string
}

export type IdentifierProps = {
  identifiers: IdentifiersItemProps[]
}

export type IdentifiersCell = {
  cellProps: any
}

export const identifiersFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  // eslint-disable-next-line no-underscore-dangle
  const { identifiers } = data._original
  let result = false

  /* eslint no-unused-expressions: [2, { allowShortCircuit: true }] */
  identifiers &&
    identifiers.forEach((item: any) => {
      if (
        (item.type && item.type.toLowerCase().includes(filter)) ||
        (item.value && item.value.toLowerCase().includes(filter)) ||
        (item.placement &&
          (item.placement.toLowerCase().includes(filter) ||
            `(${item.placement})`.toLowerCase().includes(filter)))
      ) {
        result = true
      }
    })

  return result
}

export const IdentifiersCell = (props: IdentifiersCell) => {
  const { cellProps } = props
  const { identifiers }: IdentifierProps = cellProps.original
  return (
    <>
      {identifiers
        ? identifiers.map((item: any) => {
            let display
            if (item.type === 'debtTypeSubDebtType') {
              display = `${item.value}`
            } else {
              display = `<strong>${item.type}:</strong> ${item.value}`
            }
            return (
              <Fragment key={hash(Object.values(item).join('#'))}>
                {item.value && item.placement
                  ? ReactHtmlParser(`${display} (${item.placement})<br />`)
                  : null}
                {item.value && !item.placement
                  ? ReactHtmlParser(`${display}<br />`)
                  : null}
              </Fragment>
            )
          })
        : null}
    </>
  )
}
export default IdentifiersCell
